import src from "IMAGE";
export default { src, width: 118, height: 103, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
